import React from "react";
import SelectDropdown from "../../components-react/SelectDropdown";

const CustomDropDownFilter = ({
  options,
  selectedOption,
  setSelectedOption,
  name,
}) => {
  // Check if there's actually a value selected
  // Add a class based on whether a gym is selected

  const containerClass = `timesheet_dropdown_wrapper ${
    !selectedOption ? "empty-selection" : "has-selection"
  }`;

  return (
    <div className={containerClass}>
      <SelectDropdown
        options={options?.length > 0 ? options : []}
        name={name}
        value={selectedOption}
        setSelectedOption={setSelectedOption}
        isDisable={false}
        isSearchable={true}
        preventKeyboardOpen={true}
        menuPortalTarget={document.body}
        className="custom-select-dropdown"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base, state) => ({
            ...base,
            borderColor: selectedOption
              ? "2px solid #28a745 !important"
              : "gray !important",
            "&:hover": {
              borderColor: selectedOption
                ? "2px solid #28a745 !important"
                : "gray !important",
            },
            boxShadow: state.isFocused
              ? "0 0 0 0.2rem rgba(0, 0, 0, 0.25) !important"
              : "none",
            borderRadius: "4px",
            color: "#28a745 !important",
          }),
        }}
      />
    </div>
  );
};

export default CustomDropDownFilter;
